<template>
  <div style="padding:20px;">
    <h3 style="margin-bottom:20px;">OPPO 批量修改广告主名称</h3>

    <!-- 第一步：填写 Cookie -->
    <el-card style="margin-bottom:16px;">
      <div slot="header">
        <span style="font-weight:bold;">第一步：填写 Cookie</span>
      </div>
      <el-input
        v-model="cookie"
        type="textarea"
        :rows="4"
        placeholder="请粘贴完整的 OPPO 后台 Cookie（包含 adstk、JSESSIONID、oadsk、login-access-id 等字段）"
      ></el-input>
    </el-card>

    <!-- 第二步：下载模板 + 上传 Excel -->
    <el-card style="margin-bottom:16px;">
      <div slot="header">
        <span style="font-weight:bold;">第二步：下载模板 / 上传 Excel</span>
      </div>
      <div>
        <el-button type="success" @click="downloadTemplate">下载模板</el-button>
        <el-upload
          ref="uploadRef"
          :show-file-list="false"
          accept=".xlsx,.xls"
          :before-upload="handleFileUpload"
          style="display:inline-block;margin-left:12px;"
        >
          <el-button type="warning">上传 Excel</el-button>
        </el-upload>
        <span style="margin-left:12px;font-size:12px;color:#909399;">
          仅支持 .xlsx / .xls 格式，第一行表头，从第二行起读取数据
        </span>
      </div>
    </el-card>

    <!-- 第三步：数据预览 + 批量修改 -->
    <el-card v-if="tableData.length > 0" style="margin-bottom:16px;">
      <div slot="header">
        <span style="font-weight:bold;">第三步：数据预览 / 批量修改</span>
      </div>

      <!-- 操作按钮 -->
      <div style="margin-bottom:12px;">
        <el-button
          type="primary"
          :loading="batchRunning"
          :disabled="batchRunning"
          @click="confirmBatchUpdate"
        >开始批量修改</el-button>
        <el-button
          :disabled="batchRunning"
          @click="resetStatus"
        >重置状态</el-button>
        <el-button
          :disabled="batchRunning"
          @click="clearData"
        >清空数据</el-button>
      </div>

      <!-- 结果汇总 -->
      <div v-if="batchDone" style="margin-bottom:12px;">
        <el-alert
          :type="failCount === 0 ? 'success' : 'warning'"
          :closable="false"
          show-icon
        >
          <span>
            执行完成：总计 {{ tableData.length }} 条，
            成功 <strong>{{ successCount }}</strong> 条，
            失败 <strong>{{ failCount }}</strong> 条
          </span>
          <el-button
            v-if="failCount > 0"
            type="danger"
            size="small"
            style="margin-left:16px;"
            @click="exportFailList"
          >导出失败列表</el-button>
        </el-alert>
      </div>

      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        border
        style="width:100%;"
        v-loading="tableLoading"
        max-height="600"
      >
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="ownerId" label="ownerId" min-width="140"></el-table-column>
        <el-table-column prop="newOwnerName" label="修改后名称" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="originalName" label="原始名称" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.originalName || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.status === 'pending'"
              type="info"
              size="small"
            >等待修改</el-tag>
            <el-tag
              v-else-if="scope.row.status === 'loading'"
              type="warning"
              size="small"
            ><i class="el-icon-loading"></i> 修改中…</el-tag>
            <el-tag
              v-else-if="scope.row.status === 'success'"
              type="success"
              size="small"
            >修改成功</el-tag>
            <el-tag
              v-else-if="scope.row.status === 'failed'"
              type="danger"
              size="small"
            >修改失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.remark || '-' }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";

const BASE = "https://control.zjwec.cn";

export default {
  data: function () {
    return {
      cookie: "",
      tableData: [],
      batchRunning: false,
      batchDone: false,
      tableLoading: false
    };
  },
  computed: {
    successCount: function () {
      var that = this;
      return that.tableData.filter(function (r) { return r.status === "success"; }).length;
    },
    failCount: function () {
      var that = this;
      return that.tableData.filter(function (r) { return r.status === "failed"; }).length;
    }
  },
  methods: {
    // 下载模板
    downloadTemplate: function () {
      var headers = ["ownerId", "ownerName"];
      var exampleRow = ["1001354634", "新广告主名称示例"];
      var data = [headers, exampleRow];
      var ws = XLSX.utils.aoa_to_sheet(data);
      ws["!cols"] = [{ wch: 16 }, { wch: 40 }];
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "模板");
      var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      FileSaver.saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "OPPO批量修改广告主名称_模板.xlsx"
      );
      this.$message.success("模板下载成功");
    },

    // 上传 Excel
    handleFileUpload: function (file) {
      var that = this;
      var reader = new FileReader();
      reader.onload = function (e) {
        try {
          var data = new Uint8Array(e.target.result);
          var wb = XLSX.read(data, { type: "array" });
          var sheetName = wb.SheetNames[0];
          var sheet = wb.Sheets[sheetName];
          var rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

          if (rows.length < 2) {
            that.$message.error("Excel 数据为空，至少需要一行表头和一行数据");
            return;
          }

          var parsed = [];
          var hasError = false;
          for (var i = 1; i < rows.length; i++) {
            var row = rows[i];
            if (!row || !row.length) continue;

            var ownerId = String(row[0] || "").trim();
            var newName = String(row[1] || "").trim();

            // 校验
            if (!ownerId) {
              that.$message.error("第 " + (i + 1) + " 行 ownerId 为空");
              hasError = true;
              continue;
            }
            if (!/^\d+$/.test(ownerId)) {
              that.$message.error("第 " + (i + 1) + " 行 ownerId [" + ownerId + "] 不是纯数字");
              hasError = true;
              continue;
            }
            if (!newName) {
              that.$message.error("第 " + (i + 1) + " 行 ownerName 为空");
              hasError = true;
              continue;
            }

            parsed.push({
              ownerId: ownerId,
              newOwnerName: newName,
              originalName: "",
              status: "pending",
              remark: ""
            });
          }

          if (!hasError && parsed.length === 0) {
            that.$message.warning("未解析到有效数据，请检查 Excel 内容");
            return;
          }

          that.tableData = parsed;
          that.batchDone = false;
          that.$message.success("成功解析 " + parsed.length + " 条数据");
        } catch (err) {
          console.error(err);
          that.$message.error("Excel 解析失败，请检查文件格式");
        }
      };
      reader.readAsArrayBuffer(file);
      return false;
    },

    // 二次确认弹窗
    confirmBatchUpdate: function () {
      var that = this;
      if (!that.cookie.trim()) {
        that.$message.warning("请先填写 Cookie");
        return;
      }
      if (!that.tableData.length) {
        that.$message.warning("请先上传 Excel 数据");
        return;
      }
      that.$confirm(
        "确定要批量修改 " + that.tableData.length + " 个广告主名称吗？",
        "确认批量修改",
        {
          confirmButtonText: "确定执行",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(function () {
        that.doBatchUpdate();
      }).catch(function () {});
    },

    // 执行批量修改
    doBatchUpdate: function () {
      var that = this;
      that.batchRunning = true;
      that.batchDone = false;
      that.tableLoading = true;

      // 重置状态
      that.tableData.forEach(function (r) {
        r.status = "pending";
        r.remark = "";
        r.originalName = "";
      });

      // 串行执行
      var cookie = that.cookie.trim();
      var index = 0;
      var list = that.tableData;

      function runNext() {
        if (index >= list.length) {
          // 全部完成
          that.batchRunning = false;
          that.batchDone = true;
          that.tableLoading = false;

          var successCount = that.successCount;
          var failCount = that.failCount;
          if (failCount === 0) {
            that.$message.success("全部 " + successCount + " 条修改成功");
          } else {
            that.$message.warning("成功 " + successCount + " 条，失败 " + failCount + " 条");
          }
          return;
        }

        var row = list[index];
        that.$set(row, "status", "loading");
        that.$set(row, "remark", "");

        // 步骤1：获取广告主完整信息
        axios
          .post(BASE + "/api/oppohook/customer/get", {
            cookie: cookie,
            ownerId: row.ownerId
          })
          .then(function (resp) {
            var data = resp.data;
            if (data.code == 0 && data.data) {
              var info = data.data;
              that.$set(row, "originalName", info.ownerName || "");

              // 步骤2：修改广告主信息，仅替换 ownerName
              var updateBody = {
                cookie: cookie,
                ownerId: info.ownerId,
                ownerType: info.ownerType,
                ownerName: row.newOwnerName,
                companyName: info.companyName || "",
                busiLicence: info.busiLicence || "",
                busiLicenceImg: info.busiLicenceImg || "",
                identityCardImg: info.identityCardImg || "",
                identityCardBack: info.identityCardBack || "",
                identityCardInHand: info.identityCardInHand || "",
                contactName1: info.contactName1 || "",
                contactPhone1: info.contactPhone1 || "",
                loginAcc: info.loginAcc || ""
              };

              return axios.post(BASE + "/api/oppohook/customer/update", updateBody);
            } else {
              throw new Error(data.msg || "获取广告主信息失败");
            }
          })
          .then(function (resp) {
            var data = resp.data;
            if (data.code == 0) {
              that.$set(row, "status", "success");
              that.$set(row, "remark", "修改成功，ownerId: " + data.data);
            } else {
              that.$set(row, "status", "failed");
              that.$set(row, "remark", data.msg || "修改失败");
            }
          })
          .catch(function (err) {
            that.$set(row, "status", "failed");
            var msg = "请求异常";
            if (err && err.message) msg = err.message;
            that.$set(row, "remark", msg);
          })
          .finally(function () {
            index++;
            // 延迟 300ms 避免频率限制
            setTimeout(function () {
              runNext();
            }, 300);
          });
      }

      runNext();
    },

    // 重置状态
    resetStatus: function () {
      var that = this;
      that.batchDone = false;
      that.tableData.forEach(function (r) {
        r.status = "pending";
        r.remark = "";
        r.originalName = "";
      });
      that.$message.success("状态已重置");
    },

    // 清空数据
    clearData: function () {
      var that = this;
      that.tableData = [];
      that.batchDone = false;
      that.tableLoading = false;
      that.$message.success("数据已清空");
    },

    // 导出失败列表
    exportFailList: function () {
      var that = this;
      var failList = that.tableData.filter(function (r) { return r.status === "failed"; });
      if (!failList.length) {
        that.$message.warning("没有可导出的失败数据");
        return;
      }
      var headers = [["序号", "ownerId", "修改后名称", "原始名称", "备注"]];
      var data = failList.map(function (r, i) {
        return [i + 1, r.ownerId, r.newOwnerName, r.originalName || "", r.remark || ""];
      });
      var allData = headers.concat(data);
      var ws = XLSX.utils.aoa_to_sheet(allData);
      ws["!cols"] = [
        { wch: 8 },
        { wch: 16 },
        { wch: 40 },
        { wch: 40 },
        { wch: 30 }
      ];
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "失败列表");
      var wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      FileSaver.saveAs(
        new Blob([wbout], { type: "application/octet-stream" }),
        "OPPO批量修改_失败列表.xlsx"
      );
      that.$message.success("导出成功");
    }
  }
};
</script>

<style scoped>
.el-card :deep(.el-card__header) {
  background-color: #f5f7fa;
  padding: 12px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/oppo/BatchEditAdvertiserName.vue